import logo1 from "../../images-bpo/logo-BPO.png"


export const images_bpo = [logo1]

export default images_bpo